import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useKeyboardShortcuts } from "../hooks/useKeyboardShortcuts";

const SHORTCUTS: { combo: string; label: string }[] = [
  { combo: "g d", label: "Тайлан руу шилжих" },
  { combo: "g s", label: "Үйлчилгээний жагсаалт" },
  { combo: "g b", label: "Захиалгын жагсаалт" },
  { combo: "g c", label: "Календарь" },
  { combo: "g t", label: "Өрөө ба тоног төхөөрөмж" },
  { combo: "?", label: "Энэ цонхыг харуулах" },
];

/**
 * Mounted once at the App root. Wires the global Gmail/Linear-style chord
 * shortcuts and a "?" cheatsheet dialog. Shortcuts are skipped while the
 * user is typing — the underlying hook handles that.
 */
export default function GlobalShortcuts(): JSX.Element {
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);

  const specs = useMemo(
    () => [
      { combo: "g d", handler: () => navigate("/") },
      { combo: "g s", handler: () => navigate("/service") },
      { combo: "g b", handler: () => navigate("/bookings") },
      { combo: "g c", handler: () => navigate("/calendar") },
      { combo: "g t", handler: () => navigate("/team") },
      { combo: "?", handler: () => setHelpOpen(true) },
      // Esc closes the help dialog. `Escape` is the actual key value.
      { combo: "Escape", handler: () => setHelpOpen(false), allowInInputs: true },
    ],
    [navigate],
  );
  useKeyboardShortcuts(specs);

  return (
    <Dialog open={helpOpen} onClose={() => setHelpOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Гарын товчлуурууд</DialogTitle>
      <DialogContent>
        <Stack spacing={1.25} mt={0.5}>
          {SHORTCUTS.map((s) => (
            <Box
              key={s.combo}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={2}
            >
              <Typography variant="body2">{s.label}</Typography>
              <Box
                component="kbd"
                sx={{
                  fontFamily: "monospace",
                  fontSize: 12,
                  px: 0.75,
                  py: 0.25,
                  borderRadius: 0.75,
                  border: "1px solid rgba(255,255,255,0.2)",
                  backgroundColor: "rgba(255,255,255,0.06)",
                }}
              >
                {s.combo}
              </Box>
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
